import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import RoleRoute from './components/RoleRoute';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import LinkedInPostsAll from './pages/LinkedInPostsAll';
import LinkedInPostEdit from './pages/LinkedInPostEdit';
import Agents from './pages/Agents';
import Workflows from './pages/Workflows';
import Huxley from './pages/Huxley';
import Jason from './pages/Jason';
import JasonV3 from './pages/JasonV3';
import Maya from './pages/Maya';
import ContentRequestForm from './pages/ContentRequestForm';
import WritingAnalysisForm from './pages/WritingAnalysisForm';
import WritingAnalysisResult from './pages/WritingAnalysisResult';
import AllWriters from './pages/AllWriters';
import InitiativeDocsUpload from './pages/InitiativeDocsUpload';
import MediabrandsDocsUpload from './pages/MediabrandsDocsUpload';
import VolvoDocsUpload from './pages/VolvoDocsUpload';
import CreateUser from './pages/admin/CreateUser';
import AdminUsers from './pages/admin/AdminUsers';          // New admin import
import AdminEditUser from './pages/admin/AdminEditUser';    // New admin import
import EditUser from './pages/admin/EditUser';                    // Regular user edit
import ReachCurveTool from './pages/ReachCurveTool';
import AudienceAgent from './pages/AudienceAgent';
import ChannelAgent from './pages/ChannelAgent';
import AffinityAgent from './pages/AffinityAgent';
import ReachCurvePlanner from './pages/ReachCurvePlanner';
import ReachCurveResult from './pages/ReachCurveResult';
import PersonaInterview from './pages/PersonaInterview';
import PersonaProfile from './pages/PersonaProfile';
import PersonaSurveyQuant from './pages/PersonaSurveyQuant';
import PersonaSurveyHistory from './pages/PersonaSurveyHistory';
import SurveyAnalysisDashboard from './pages/SurveyAnalysisDashboard';
import BMGStreaming from './pages/BMGStreaming';
import Login from './pages/Login';
import './styles/Global.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <div style={{ padding: '20px' }}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/agents" element={
              <ProtectedRoute>
                <Agents />
              </ProtectedRoute>
            } />
            <Route path="/workflows" element={
              <ProtectedRoute>
                <Workflows />
              </ProtectedRoute>
            } />
            <Route path="/agent/huxley" element={
              <ProtectedRoute>
                <Huxley />
              </ProtectedRoute>
            } />
            <Route path="/agent/jason" element={
              <ProtectedRoute>
                <JasonV3 />
              </ProtectedRoute>
            } />
            <Route path="/agent/maya" element={
              <ProtectedRoute>
                <Maya />
              </ProtectedRoute>
            } />
            <Route path="/writinganalysisform" element={
              <ProtectedRoute>
                <WritingAnalysisForm />
              </ProtectedRoute>
            } />
            <Route path="/allwriters" element={
              <ProtectedRoute>
                <AllWriters />
              </ProtectedRoute>
            } />
            <Route path="/contentrequestform" element={
              <ProtectedRoute>
                <ContentRequestForm />
              </ProtectedRoute>
            } />
            <Route path="/linkedinpostsall" element={
              <ProtectedRoute>
                <LinkedInPostsAll />
              </ProtectedRoute>
            } />
            <Route path="/posts/edit/:id" element={
              <ProtectedRoute>
                <LinkedInPostEdit />
              </ProtectedRoute>
            } />
            <Route path="/initiativedocsupload" element={
              <ProtectedRoute>
                <InitiativeDocsUpload />
              </ProtectedRoute>
            } />
            <Route path="/reachcurvetool" element={
              <ProtectedRoute>
                <ReachCurveTool />
              </ProtectedRoute>
            } />
            <Route path="/writinganalysisresult/:name" element={
              <ProtectedRoute>
                <WritingAnalysisResult />
              </ProtectedRoute>
            } />
            <Route path="/mediabrandsdocsupload" element={
              <ProtectedRoute>
                <MediabrandsDocsUpload />
              </ProtectedRoute>
            } />
            <Route path="/volvodocsupload" element={
              <RoleRoute allowedRoles={['admin', 'volvo']}>
                <VolvoDocsUpload />
              </RoleRoute>
            } />
            <Route path="/agent/ed" element={
              <ProtectedRoute>
                <AudienceAgent />
              </ProtectedRoute>
            } />
            <Route path="/agent/channel" element={
              <ProtectedRoute>
                <ChannelAgent />
              </ProtectedRoute>
            } />
            <Route path="/agent/affinity" element={
              <ProtectedRoute>
                <AffinityAgent />
              </ProtectedRoute>
            } />
            <Route path="/reachcurve/planner" element={
              <ProtectedRoute>
                <ReachCurvePlanner />
              </ProtectedRoute>
            } />
            <Route path="/reachcurve/result/:id" element={
              <ProtectedRoute>
                <ReachCurveResult />
              </ProtectedRoute>
            } />
            <Route path="/persona-interview" element={
              <ProtectedRoute>
                <PersonaInterview />
              </ProtectedRoute>
            } />
            <Route path="/persona-profile/:foundationId" element={
              <ProtectedRoute>
                <PersonaProfile />
              </ProtectedRoute>
            } />
            <Route path="/persona-survey-quant" element={
              <ProtectedRoute>
                <PersonaSurveyQuant />
              </ProtectedRoute>
            } />
            <Route path="/persona-survey-history" element={
              <ProtectedRoute>
                <PersonaSurveyHistory />
              </ProtectedRoute>
            } />
            <Route path="/persona-survey-results/:surveyId" element={
              <ProtectedRoute>
                <PersonaSurveyQuant />
              </ProtectedRoute>
            } />
            <Route path="/survey-analysis/:surveyId" element={
              <ProtectedRoute>
                <SurveyAnalysisDashboard />
              </ProtectedRoute>
            } />
            <Route path="/bmg-streaming" element={
              <ProtectedRoute>
                <BMGStreaming />
              </ProtectedRoute>
            } />

            {/* User Profile Routes */}
            <Route path="/edit-user" element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            } />
            
            {/* Admin-Only Routes */}
            <Route path="/admin/create-user" element={
              <RoleRoute allowedRoles={['admin']}>
                <CreateUser />
              </RoleRoute>
            } />
            <Route path="/admin/users" element={
              <RoleRoute allowedRoles={['admin']}>
                <AdminUsers />
              </RoleRoute>
            } />
            <Route path="/admin/edit-user/:userId" element={
              <RoleRoute allowedRoles={['admin']}>
                <AdminEditUser />
              </RoleRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;